// src/api/client.js
import config from '../config/env';

const API_BASE_URL = config.apiUrl;

export const apiClient = async (endpoint, options = {}) => {
  const makeRequest = async () => {
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    if (options.body instanceof FormData) {
      delete headers['Content-Type'];
    }
    
    const config = {
      method: options.method || 'GET',
      headers,
      credentials: 'include',
      ...options,
    };
    
    if (options.body && !['GET', 'HEAD'].includes(config.method)) {
      if (options.body instanceof FormData) {
        config.body = options.body;
      } else if (typeof options.body === 'string') {
        config.body = options.body;
      } else {
        config.body = JSON.stringify(options.body);
      }
    }
    
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      data = await response.text();
    }
    
    if (!response.ok) {
      const error = new Error(data.message || data?.detail || data || `HTTP ${response.status}`);
      error.status = response.status;
      error.data = data;
      throw error;
    }
    
    return { ok: true, status: response.status, data };
  };
  
  try {
    return await makeRequest();
  } catch (error) {
    // If 401, just throw the error - don't try to refresh
    throw error;
  }
};

export const api = {
  get: (endpoint, options = {}) => apiClient(endpoint, { ...options, method: 'GET' }),
  post: (endpoint, body, options = {}) => apiClient(endpoint, { ...options, method: 'POST', body }),
  put: (endpoint, body, options = {}) => apiClient(endpoint, { ...options, method: 'PUT', body }),
  patch: (endpoint, body, options = {}) => apiClient(endpoint, { ...options, method: 'PATCH', body }),
  delete: (endpoint, options = {}) => apiClient(endpoint, { ...options, method: 'DELETE' }),
};

export const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API_BASE_URL}${path}`;
};

export default api;